import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
var css = {
  "pageItem": "rui-mfEVU",
  "selected": "rui-xA1NB"
};
var PageItem = function PageItem(_ref) {
  var children = _ref.children,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    onClick = _ref.onClick,
    _ref$dataAutId = _ref['data-aut-id'],
    dataAutId = _ref$dataAutId === void 0 ? 'pageItem' : _ref$dataAutId;
  return /*#__PURE__*/React.createElement("button", {
    className: classNames(css.pageItem, _defineProperty({}, css.selected, selected)),
    type: "button",
    "data-aut-id": dataAutId,
    onClick: onClick
  }, children);
};
export default PageItem;